import ProfileLogo from '@components/ProfileLogo'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { Theme, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const ResultCardItemContainer = styled('div')`
  margin-bottom: 16px;

  min-height: 210px;
  position: relative;
`

export const ResultCardNewItemWrapper = styled('div')`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: transparent;
  border: 1px solid ${colors.primary};
  position: relative;
  overflow: hidden;
`

export const ResultCardNewItemIndicator = styled('div')`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: transparent;
  border: 1px solid ${colors.primary};
`

export const ResultCardGroupSubItemContainer = styled('div')`
  margin-bottom: 16px;
  width: 100%;
  min-height: 210px;
  padding-left: 40px;
`

export const ResultCardItemInner = styled('div')`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  background: ${colors.white};
  border-radius: 8px;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
  ${(props: { $isPrimary?: boolean }) =>
    `
      border: 1px solid ${props.$isPrimary ? colors.primary : colors.lightGrey};
    `};

  ${(props: { theme: Theme }) => props.theme.breakpoints.down('xs')} {
    padding: 10px;
  }
`

export const NewItemButtonWrapper = styled('div')`
  position: absolute;
  bottom: 0;
  left: 0;
`

export const ProfileCardHeaderContainer = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: ${componentSizes.smDistance};
  border-bottom: 1px solid ${colors.lightGrey};
`

export const ProfileLogoWrapper = styled('div')`
  min-width: 43px;
  max-width: 43px;
  max-height: 43px;

  ${(props: { theme: Theme }) => props.theme.breakpoints.down('xs')} {
    min-width: 23px;
    max-width: 23px;
    max-height: 23px;
  }

  margin-right: 10px;
  position: relative;
`

export const StyledProfileLogo = styled(ProfileLogo)`
  min-width: 43px;
  max-width: 43px;
  max-height: 43px;

  ${(props: { theme: Theme }) => props.theme.breakpoints.down('xs')} {
    min-width: 23px;
    max-width: 23px;
    max-height: 23px;
  }
  position: relative;
`

export const ResultProfileLogo = styled(CardMedia)`
  position: absolute;
  bottom: -12px;

  ${(props: { $roundImage?: boolean }) =>
    props.$roundImage
      ? `
          border-radius: 50%;
          overflow: hidden;
          bottom: -18px;
        `
      : ''}
`
export const ProfileHeaderTitleContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ProfileHeaderTitle = styled('div')`
  display: flex;
`

export const ProfileHeaderButtonsContainer = styled('div')`
  display: flex;
`

export const ResultCardProfileTitle = styled(Typography)`
  margin-right: 10px;
  max-width: 480px;
  word-break: break-word;
  cursor: pointer;
`

export const ProfileDateBox = styled('div')`
  display: flex;
  gap: 6px;
  padding: 2px 0;
  align-items: flex-start;
`

export const ProfileDate = styled(Typography)`
  white-space: nowrap;
`

export const ProfileCardContentContainer = styled('div')`
  display: flex;
  padding-top: ${componentSizes.smDistance};
`

export const MainTextWrapper = styled('div')`
  min-width: 300px;
  width: 100%;
  height: 100%;
  padding-right: ${componentSizes.smDistance};
`

export const SecondaryTextWrapper = styled('div')`
  min-width: 200px;
  height: 100%;
  width: 100%;
  padding-right: ${componentSizes.smDistance};
  padding-left: ${componentSizes.smDistance};
  border-left: 1px solid ${colors.lightGrey};

  ${(props: { theme: Theme }) => props.theme.breakpoints.down('sm')} {
    padding-left: 0;
    border-left: none;
  }
`

export const ThirdTextWrapper = styled(SecondaryTextWrapper)``

export const FieldSectionContainer = styled('div')`
  margin-bottom: ${componentSizes.smDistance};
  word-break: break-word;
`

export const FieldText = styled(Typography)`
  /** Below css properties does text truncation exactly to 5 lines */
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`

export const FieldTitle = styled(Typography)`
  line-height: 100%;
  letter-spacing: 0.0175em;
  padding-bottom: 4px;
`

export const ProfileCardFooterContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
`

export const ShortlistProfileButtonWrapper = styled('div')`
  padding: 20px;
`

export const UpdatedLabel = styled('div')`
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 3px 8px;
  background-color: ${colors.primary};
  font-size: 15px;
  font-weight: 500;
  color: ${colors.white};
`
